export { sendSlackMessage };

async function sendSlackMessage(text, channel = "UE04CRG9F") {
  return fetch(
    `https://slack.com/api/chat.postMessage?token=xoxb-464931347856-603068707909-4Bbipve02DXUM2jQahSdXGNj&channel=${channel}&text=${text}`,
    {
      method: "POST"
    }
  )
    .then(res =>
      res.json().then(json => {
        if (!res.ok) throw new Error(json.message || res.statusText);
        return json;
      })
    )
    .catch(err => {
      return Promise.reject(new Error(err.message));
    });
}
